export default __webpack_public_path__ + "static/1-59994bf4642a092bae1c90c6502b6c16.png";